import { Component, computed, ElementRef, inject, input, model, signal, ViewChild } from '@angular/core';
import { TableModule } from '@openng/optimus-ui/table';
import { CraftType, SvgIconsComponent } from '@zayan-erp/shared';
import { ProductCraftsPreviewCardComponent } from '../product-crafts-preview-card/product-crafts-preview-card.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { rxResourceFixed } from '@zayan-erp/shared';
import { CraftEntityService } from '../../../services/craft-entity.service';
import { NgbDropdownModule, NgbModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalService } from '@zayan-erp/shared';
import { ProductCraftsFormComponent } from '../product-crafts-form/product-crafts-form.component';
import { ProductCraftService } from '../../../services/product-craft.service';
import { of } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
  selector: 'lib-product-crafts',
  imports: [
    TableModule,
    SvgIconsComponent,
    ProductCraftsPreviewCardComponent,
    NgbModalModule,
    ProductCraftsFormComponent,
    NgbDropdownModule,
    FormsModule,
    NgClass
  ],
  templateUrl: './product-crafts.component.html'
})
export class ProductCraftsComponent {
  @ViewChild('addCraftModal') addCraftModal?: ElementRef;
  #modalService = inject(NgbModal);
  #ngbModelService = inject(NgbModalService);
  #craftEntityService = inject(CraftEntityService);
  #productCraftService = inject(ProductCraftService);

  productId = input<string | null>(null);

  craftEntities = toSignal(this.#craftEntityService.readCraftEntities());
  CraftTypeEnum = CraftType;
  search = signal<string>('');
  selectedCraftId = model<string | null>(null);
  selectedProductCraftId = model<string | null>(null);
  craftEntitiesList = computed(
    () =>
      this.craftEntities()
        ?.filter(craft => !this.productCraftsList().some(productCraft => productCraft.craftId === craft.id))
        ?.filter(
          craft =>
            craft.code.toLowerCase().includes(this.search().toLowerCase()) ||
            craft.description.toLowerCase().includes(this.search().toLowerCase())
        ) ?? []
  );
  productCraftsList = computed(() => this.productCrafts.value() ?? []);

  productCrafts = rxResourceFixed({
    params: () => ({ productId: this.productId()! }),
    defaultValue: [],
    stream: ({ params }) => {
      if (params.productId) {
        return this.#productCraftService.readProductCraftByProductId(params.productId!);
      }
      return of([]);
    }
  });

  openAddCraftModal() {
    this.#modalService.open(this.addCraftModal, this.#ngbModelService.centerModal);
  }

  closeModal() {
    this.selectedCraftId.set(null);
    this.selectedProductCraftId.set(null);
    this.#modalService.dismissAll();
  }
  removeProductCraft(productCraftId: string) {
    this.#productCraftService.deleteProductCraft(productCraftId).subscribe({
      next: () => {
        this.productCrafts.reload();
      }
    });
  }
}
